import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { MustMatch } from 'src/app/helpers/validators/must-match.validator';
import * as moment from 'moment';
import { CustomAlertService } from 'src/app/core/services/custom-alert.service';
import Swal from 'sweetalert2';
moment.locale('es');

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./../login/login.component.scss']
})
export class RecoverPasswordComponent implements OnInit {

  recoverForm: UntypedFormGroup;
  public token: any;
  public date: any;
  public dateToken: any;
  public type: any;
  public submitted = false;
  public success = true;
  showPassword = false;
  showPassword2 = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public http: HttpClient,
    public router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthService,
    private customAlert: CustomAlertService
  ) {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.dateToken = params['date'];
      this.type = params['type'];
      if (this.token && this.dateToken) {
        const startdate = moment();
        this.date = moment(startdate);
        this.dateToken = moment(this.dateToken);
        // let number = this.date.diff(this.dateToken, 'minutes');
        // if (number < 30) {
        const time = this.date.diff(this.dateToken, 'hours');
        if (time < 24) {
          if (this.token.length > 0) { /* empty */ } else {
            window.location.replace('https://www.gaspre.com');
          }
        } else {
          window.location.replace('https://www.gaspre.com');
        }
      } else {
        window.location.replace('https://www.gaspre.com');
      }
    });
  }

  ngOnInit() {
    this.recoverForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(8), Validators.pattern('.{8,}')]],
      confirm_password: ['', [Validators.required, Validators.minLength(8)]]
    }, {
      validator: MustMatch('password', 'confirm_password')
    });
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  togglePassword2Visibility() {
    this.showPassword2 = !this.showPassword2;
  }

  get f() { return this.recoverForm.controls; }

  async onSubmit() {

    this.submitted = true;

    // stop here if form is invalid
    if (this.recoverForm.invalid) {
      return;
    }

    const valido = await this.authenticationService.setPassword(this.recoverForm.value, this.token);

    if (valido) {
      // mostrar password exitoso
      Swal.fire({
        title: '¡Éxito!',
        text: 'Tu contraseña ha sido actualizada correctamente.',
        icon: 'success',
        confirmButtonColor: '#00e07b',
        confirmButtonText: 'Aceptar'
      }).then((result) => {
        if (result.isConfirmed) {
          // Redirigir al usuario después de aceptar
          this.router.navigate(['/login']);
        }
      });
    } else {
      // mostrar error token expirado
      this.customAlert.showError('¡No se pudo actualizar la contraseña!', 'Intentalo más tarde');
    }

  }

}
